export enum FeatureFlagKeys {
    NewAddCreditCardFlow = 'ff_new_add_credit_card_flow',
    NewAuthPagerModal = 'ff_new_auth_pager_modal',
    AbsenteeBidsDefectionService = 'ff_use_absentee_bids_defection_service',
    VipBenefits = 'ff_vip_benefits',
}
// TODO: Add feature flags here
// NewItemPageLayout = 'ff_laac-5678_new-item-page-layout',

export type FeatureFlags = Partial<Record<FeatureFlagKeys, boolean>>;
